import { render, staticRenderFns } from "./ControlBox.vue?vue&type=template&id=3e7a3868&scoped=true"
import script from "./ControlBox.vue?vue&type=script&lang=js"
export * from "./ControlBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7a3868",
  null
  
)

export default component.exports